window.cbdCalculator = function() {
    let calcWrapper = document.querySelector('.js-cbd-calc');
    const mlDrops = 30;
    
    let weight = calcWrapper.querySelector('.js-cbd-calc__weight').value;
    let dosage = calcWrapper.querySelector('.js-cbd-calc__dosage').value;
    let cbdVolume = calcWrapper.querySelector('.js-cbd-calc__cbd-volume').value;
    let containerVolume = calcWrapper.querySelector('.js-cbd-calc__container-volume').value;
    let resutlWrapper = calcWrapper.querySelector('.js-cbd-calc__result');

    if(!weight || !dosage || !cbdVolume || !containerVolume) {
        resutlWrapper.innerHTML = "Zadejte správné údaje";
        return;
    }

    let dropName = null;
    

    let mgCBD = weight * dosage;

    let drop = cbdVolume / containerVolume;
    
    let result = drop / mlDrops;
    result = mgCBD / result;

    if(drop < 2 && drop > 1) {
        dropName = " kapka";
    }
    else if(drop > 2 && drop < 5) {
        dropName = " kapky";
    }
    else {
        dropName = " kapek";
    }

    resutlWrapper.innerHTML = Math.round(result);
    resutlWrapper.classList.add('c-cbd-calc__result--active');
    resutlWrapper.innerHTML = "Vaše doporučená denní dávka je " + Math.round(result) + dropName +" nebo " + mgCBD + " mg CBD";
}